import styles from './styles.module.css'

const cloudinaryUrl = 'https://images.angelstudios.com/image/upload'

export const InfiniteScrollCarousel = ({
  images,
  speed = 80000,
}: {
  images: { alt: string; src: string }[]
  speed?: number
}) => {
  return (
    <div className={styles.inner}>
      <div className={styles.wrapper}>
        <section className={styles.container} style={{ '--speed': `${speed}ms` } as React.CSSProperties}>
          {images.map(({ alt, src }) => (
            <div style={{ padding: '0 20px' }} key={alt}>
              <img src={`${cloudinaryUrl}${src}`} alt={alt} />
            </div>
          ))}
        </section>
        <section className={styles.container} style={{ '--speed': `${speed}ms` } as React.CSSProperties}>
          {images.map(({ alt, src }) => (
            <div style={{ padding: '0 20px' }} key={alt}>
              <img src={`${cloudinaryUrl}${src}`} alt={alt} />
            </div>
          ))}
        </section>
        <section className={styles.container} style={{ '--speed': `${speed}ms` } as React.CSSProperties}>
          {images.map(({ alt, src }) => (
            <div style={{ padding: '0 20px' }} key={alt}>
              <img src={`${cloudinaryUrl}${src}`} alt={alt} />
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}
